import { render, staticRenderFns } from "./AccountRecovery.vue?vue&type=template&id=2f7fdfc8&scoped=true&"
import script from "./AccountRecovery.vue?vue&type=script&lang=js&"
export * from "./AccountRecovery.vue?vue&type=script&lang=js&"
import style0 from "./AccountRecovery.vue?vue&type=style&index=0&id=2f7fdfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7fdfc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7fdfc8')) {
      api.createRecord('2f7fdfc8', component.options)
    } else {
      api.reload('2f7fdfc8', component.options)
    }
    module.hot.accept("./AccountRecovery.vue?vue&type=template&id=2f7fdfc8&scoped=true&", function () {
      api.rerender('2f7fdfc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Login/AccountRecovery.vue"
export default component.exports